/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class ModuleRequest extends MainRequest{


     static listAll() {
         return this.getSEC(ServicePath.MODULE_LIST_ALL);
     }
     static all() {
         return this.getSEC(ServicePath.MODULE_LIST);
     }
     
     static listAllWithPermissions() {
      return this.postSEC(ServicePath.MODULE_LIST_ALL_WITH_PERMISSIONS);
     }
     static listAllWithPermissionsWithRol(data) {
      return this.postSEC(ServicePath.MODULE_LIST_ALL_WITH_PERMISSIONS_BY_ROL, data);
     }

     static add(object) {
        return this.postSEC(ServicePath.MODULE_ADD, object);
     }

     static update(object) {
        return this.postSEC(ServicePath.MODULE_UPDATE, object);
     }

     static get(object) {
        return this.postSEC(ServicePath.MODULE_GET, object);
     }

     static delete(object) {
        return this.postSEC(ServicePath.MODULE_DELETE, object);
     }

 }